import { render, staticRenderFns } from "./Detail-rental-items.vue?vue&type=template&id=e245d0d2"
import script from "./Detail-rental-items.vue?vue&type=script&lang=js"
export * from "./Detail-rental-items.vue?vue&type=script&lang=js"
import style0 from "./Detail-rental-items.vue?vue&type=style&index=0&id=e245d0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports